import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';


export const updateCrmIdsUpdateSlice = getBulkActionSlice(
    'crmIdUpdateResult',
);

export const selectUpdateCrmIdsShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.crmIdsUpdateResult.shown;

export const selectUpdateCrmIdsUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.crmIdsUpdateResult.uuid;

export const selectUpdateCrmIdsTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.crmIdsUpdateResult.backgroundTask;


export const {
    setShown,
    setUuid,
    setBackgroundTask,
    clearResult,
} = updateCrmIdsUpdateSlice.actions;
